<template>
	<div class="reversing-index-main-div" :style="'max-width:' + windowObj.box_width + 'px' ">
		<div class="head-div">
			<div class="search-bar-div">
				<div class="country-select-div">
					<div class="group">
						<el-dropdown trigger="click" placement="bottom" @command="(v) => search.country=v">
							<span style="font-size: 14px;color: #909399;cursor: pointer;">
								<i :class="'fi fi-' + getCountryObjByCity(search.country).icon"> </i>
								<i class="el-icon-arrow-down" style="margin-left: 5px;font-size: 14px;"></i>
							</span>
							<el-dropdown-menu slot="dropdown" class="country-dropdown-202211111901">
								<el-dropdown-item v-for="item in countryList" :key="item.value"
									:disabled="search.country===item.value"
									:command="item.value">
									<i :class="'fi fi-' + item.icon.toLowerCase()"></i>{{ item.cn }}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
				<div style="flex: 1">
					<el-input class="el-input-20220818" placeholder="请输入ASIN，多个用逗号分隔" v-model="searchValue"
						clearable></el-input>
				</div>
				<div class="search-div">
					<el-button @click="searchFun(null)"
						style="width: 100px;border-radius: 0;height:38px" type="primary">搜索
					</el-button>
				</div>
			</div>

			<div class="example-div">
				<span>示例：</span>
				<a v-for="(item,index) in freeAsin" :key="index" @click="clickSearchTerm(item)">{{ item }}</a>
			</div>
		</div>


		<div class="body-div">
			<div class="search-info-div" v-if="searchData.total != null && searchData.total != undefined">
				<div class="condition-div">
					<div style="flex: 1;">
						搜索到
						{{ void(resultsNum = searchData.resultsNum || 0) }}
						<span style="color: #F56C6C;">{{ resultsNum }}</span> 个结果，
						<span v-if="searchData.variantsNum != null && searchData.variantsNum != undefined">
							其余
							<span style="color: #F56C6C;">{{ searchData.total - resultsNum  }}</span> 个为同组变体，
							另有
							<span style="color: #F56C6C;">
								{{
									searchData.variantsNum > searchData.total ? searchData.variantsNum - searchData.total + resultsNum || 0 : 0
								}}
							</span>个变体因没有进入前1页的流量词而未展示
						</span>
					</div>
				</div>
			</div>
			<div class="table-div" v-loading="tableLoading">
				<el-table :data="searchData.list" class="el-table-20220818" ref="elTable"
					v-if=" Object.keys(searchData).length > 0"
					header-row-class-name="el-table-header-row-20220818" @sort-change="tableSortChanged">
					<el-table-column type="index" width="50" label="#" align="center"></el-table-column>
					<el-table-column label="产品信息" header-align="center" min-width="330px">
						<template slot-scope="scope">
							<div style="float: left;text-align: center;width: 120px">
								<asin-simple-sub :country="searchData.country"
									:height="70" :width="70" :asinInfo="scope.row"></asin-simple-sub>
								<div class="asin-div">
									<span :style="'color:' +( searchData.asin !== scope.row.asin ? '' : '#409EFF') ">
										<copy-sub :value="scope.row.asin">
											<span style="cursor: pointer">
												{{ scope.row.asin }}
											</span>
										</copy-sub>
										<span v-if="searchData.asin.indexOf(scope.row.asin) === -1">(变体)</span>
									</span>
								</div>
							</div>
							<div style="margin-left: 140px;font-size: 13px;line-height: 1.5;">
								<div class="overflow-three-line" style="height: 59px">
									{{ scope.row.product_title }}
								</div>
								<div style="color: #909399;" class="overflow-one-line">
									<span v-if="scope.row.attributes">
										<span v-for="(item,index) in scope.row.attributes" :key="index">
											{{ item.dimension }} : {{ item.value }}
											<span v-if="index !== scope.row.attributes.length -1"> | </span>
										</span>
									</span>
									<span v-else class="no-data-font"> -- </span>
								</div>
								<div style="display: flex;">
									<span v-if="scope.row.price" style="color: #F56C6C; margin-right: 5px;">
										{{ scope.row.price.raw }}
									</span>
									<el-rate v-model="scope.row.stars" class="el-tate-20220818"
										disabled></el-rate>
									<span style="color: #E6A23C; margin-right: 5px;">({{ scope.row.stars }})</span>
									<span>{{ toThousands(scope.row.ratings) }}</span>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="流量来源" width="200" header-align="center">
						<template slot="header" slot-scope="scope">
							<el-popover placement="top" trigger="hover" width="220">
								<div>
									指能够为产品带来曝光或点击的流量来源，包括自然搜索、PPC广告、亚马逊官方推荐
									（比如Best Seller、Amazon's Choice、Editorial Recommendation）
								</div>
								<span slot="reference">
									流量来源
									<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<div style="margin-bottom: 10px">
								<!--								<el-tag size="small">自然排名</el-tag>-->
								<el-tooltip effect="dark" content="自然搜索结果" placement="top">
									<el-tag :type="getTagType(scope.row.organic,'primary')"
										:class="scope.row.organic <= 0 ? 'user-disabled' : ''" size="medium">自然
									</el-tag>
								</el-tooltip>
							</div>
							<div style="margin-bottom: 10px">
								<!--								<el-tag size="small" type="success">PPC广告</el-tag>-->
								<el-tooltip effect="dark" content="Sponsored Product，商品推广" placement="top">
									<el-tag size="medium" :type="getTagType(scope.row.sp,'success')"
										:class="!scope.row.sp > 0 ? 'user-disabled' : ''">SP
									</el-tag>
								</el-tooltip>

								<el-tooltip effect="dark" content="Sponsored Brand，品牌推广" placement="top">
									<el-tag size="medium" :class="scope.row.sb <= 0 ? 'user-disabled' : ''"
										style="margin-left: 5px" :type="getTagType(scope.row.sb,'success')">SB
									</el-tag>
								</el-tooltip>

								<el-tooltip effect="dark" content="Sponsored Brand Video, 品牌视频" placement="top">
									<el-tag size="medium" :class="scope.row.sbv <= 0 ? 'user-disabled' : ''"
										style="margin-left: 5px" :type="getTagType(scope.row.sbv,'success')">SBV
									</el-tag>
								</el-tooltip>
							</div>
							<div>

								<el-tooltip effect="dark" content="Amazon Choice, 亚马逊推荐" placement="top">
									<el-tag size="medium" :class="scope.row.ac <= 0 ? 'user-disabled' : ''"
										:type="getTagType(scope.row.ac,'warning')">AC
									</el-tag>
								</el-tooltip>

								<!--								<el-tag size="small" type="warning">官方推荐</el-tag>-->
								<el-tooltip effect="dark" content="Editorial Recommendations, 编辑推荐" placement="top">
									<el-tag size="medium" :class="scope.row.er <= 0 ? 'user-disabled' : ''"
										style="margin-left: 5px" :type="getTagType(scope.row.er,'warning')">ER
									</el-tag>
								</el-tooltip>

								<el-tooltip effect="dark" content="Highly Rated, 高度评价" placement="top">
									<el-tag size="medium" :class="scope.row.hr <= 0 ? 'user-disabled' : ''"
										style="margin-left: 5px" :type="getTagType(scope.row.hr,'warning')">HR
									</el-tag>
								</el-tooltip>

								<el-tooltip effect="dark" content="Top Rated From Our Brands, 高评价品牌" placement="top">
									<el-tag size="medium" :class="scope.row.tr <= 0 ? 'user-disabled' : ''"
										style="margin-left: 5px" :type="getTagType(scope.row.tr,'warning')">TR
									</el-tag>
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="全部流量词" prop="total" align="center" width="90" sortable>
						<template slot="header" slot-scope="scope">
							<el-popover placement="bottom" trigger="hover" width="200">
								<div>
									指自然流量词、广告流量词和亚马逊官方推荐词合并去重后的流量词数量
								</div>
								<span slot="reference">全部
									<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<span class="underline-dashed-line link-span">
								<a @click="clickValue(scope.row.asin)" target="_blank">
									{{ scope.row.total }}
								</a>
							</span>
						</template>
					</el-table-column>
					<el-table-column label="自然流量词" prop="organic" align="center" width="90" sortable>
						<template slot="header" slot-scope="scope">
							<el-popover placement="bottom" trigger="hover">
								<div>
									进入自然搜索结果前1页的流量词。
								</div>
								<span slot="reference">自然
									<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<span class="underline-dashed-line link-span">
								<a @click="clickValue(scope.row.asin,'organic')" class="color-text-blue">
									{{ scope.row.organic }}
								</a>
							</span>
						</template>
					</el-table-column>
					<el-table-column label="SP广告词" prop="sp" align="center" width="80" sortable>
						<template slot="header" slot-scope="scope">
							<el-popover placement="bottom" trigger="hover" width="200">
								<div>
									PPC广告的一种，也是最常见的一种，打了该类广告词的产品混杂在自然搜索结果中，具备sponsored标识，一般在自然搜索结果的前中后部都有分布。
									每页展示16条时，广告数量一般为4个，每页展示48条时，一般广告数量为12个。
								</div>
								<span slot="reference">SP
									<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<span class="underline-dashed-line link-span">
								<a @click="clickValue(scope.row.asin,'sp')" style="color: #67C23A;">
									{{ scope.row.sp }}
								</a>
							</span>
						</template>
					</el-table-column>
					<el-table-column label="品牌广告词" prop="sb" align="center" width="80" sortable>
						<template slot="header" slot-scope="scope">
							<el-popover placement="bottom" trigger="hover" width="200">
								<div>
									PPC广告的另一种，一般在搜索结果顶部或底部出现，通常会通过几个优质产品引导买家点击跳转到品牌或店铺页面。
								</div>
								<span slot="reference">SB
									<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<span class="underline-dashed-line link-span">
								<a @click="clickValue(scope.row.asin,'sb')" style="color: #67C23A;">
									{{ scope.row.sb }}
								</a>
							</span>
						</template>
					</el-table-column>
					<el-table-column label="视频广告词" prop="sbv" align="center" width="90" sortable>
						<template slot="header" slot-scope="scope">
							<el-popover placement="bottom" trigger="hover" width="200">
								<div>
									在搜索结果列表中部出现的一种默认静音播放的视频广告，会占据一整行的位置。
								</div>
								<span slot="reference">SBV
									<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<span class="underline-dashed-line link-span">
								<a style="color: #67C23A;" @click="clickValue(scope.row.asin,'sbv')">
									{{ scope.row.sbv }}
								</a>
							</span>
						</template>
					</el-table-column>
					<el-table-column label="AC推荐词" align="center" width="90" sortable prop="ac">
						<template slot="header" slot-scope="scope">
							<el-popover placement="bottom" trigger="hover" width="200">
								<div>
									当某个产品在某个关键词下的曝光和转化效果理想，就可以获得亚马逊官方颁发的Amazon’s Choice标记，
									买家搜索该词时，亚马逊会为该产品打上一个特殊的标记，或者在搜索与该词高度相关的词时出现在Amazon's Choice推荐专栏。
									两者都会显著提高产品的曝光和转化。简称AC推荐词。
								</div>
								<span slot="reference">AC
									<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<span class="underline-dashed-line link-span">
								<a @click="clickValue(scope.row.asin,'ac')" style="color: #E6A23C;">
									{{ scope.row.ac }}
								</a>
							</span>
						</template>
					</el-table-column>
					<el-table-column label="ER推荐词" align="center" prop="er" width="80" sortable>
						<template slot="header" slot-scope="scope">
							<el-popover placement="bottom" trigger="hover" width="200">
								<div>
									亚马逊官方或者某些博主整理的主题测评帖中的产品，会以专栏的形式占据一整行的位置，
									专栏全名叫Editorial Recommendation，简称ER推荐词。
								</div>
								<span slot="reference">ER
									<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<span class="underline-dashed-line link-span">
								<a style="color: #E6A23C;" @click="clickValue(scope.row.asin,'er')">
									{{ scope.row.er }}
								</a>
							</span>
						</template>
					</el-table-column>

					<el-table-column label="HR推荐词" align="center" prop="hr" width="90" sortable>
						<template slot="header" slot-scope="scope">
							<el-popover placement="bottom" trigger="hover" width="200">
								<div>
									Highly rated：PPC广告的一种，要求产品评分星级在4星以上，且评分数量超过100条
								</div>
								<span slot="reference">HR
									<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<span class="underline-dashed-line link-span">
								<a style="color: #E6A23C;" @click="clickValue(scope.row.asin,'hr')">
									{{ scope.row.hr }}
								</a>
							</span>
						</template>
					</el-table-column>

					<el-table-column label="TR推荐词" align="center" prop="tr" width="80" sortable>
						<template slot="header" slot-scope="scope">
							<el-popover placement="bottom" trigger="hover" width="200">
								<div>
									Top Rated 或Top Rated From Our Brand（Our Brand指亚马逊自有品牌或授权品牌），
									表示某个关键词下广受好评的产品，亚马逊专门为其开辟专门的免费专栏
								</div>
								<span slot="reference">TR
									<i slot="reference" class="fa fa-question-circle-o" aria-hidden="true"></i>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<span class="underline-dashed-line link-span">
								<a style="color: #E6A23C;" @click="clickValue(scope.row.asin,'tr')">
									{{ scope.row.tr }}
								</a>
							</span>
						</template>
					</el-table-column>

				</el-table>
			</div>

			<div class="page-div">
				<el-pagination background layout="prev, pager, next" @current-change="tablePageChange"
					hide-on-single-page
					:page-size="search.pageSize" :current-page="search.page" :total="searchData.total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { COUNTRY_CODE_MAP2, getCountryObjByCity } from "@/components/config/countryCodeConfig";
import { throttle } from "@/components/common/utils/util";
import { api_sourcesList_traffic } from "@/components/api/traffic";
import regular from "@/components/common/utils/regular";
import { toThousands } from "@/components/common/utils/fomatNum";
import COPY_SUB from "@/components/template/otherSub/copySub";
import ASIN_SIMPLE_SUB from "@/components/template/view/reverse/asin/asinSimpleSub";

export default {
	name: 'reversingIndex',
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'LOGINUSER'],
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
			countryList: COUNTRY_CODE_MAP2,
			tableLoading: false,
			searchValue: '',
			search: {
				page: 1,
				pageSize: 20,
				country: 'US',
				searchTerm: [],
				sort: '',
			},
			searchData: {},
		}
	},
	computed : {
		freeAsin(){
			if (!this.$data.search.country || this.$data.search.country.toLowerCase() === 'us'){
				return ["B09C5RG6KV", "B075SZQN9Q", "B073WRLNS9"]
			}else if (this.$data.search.country.toLowerCase() === 'uk'){
				return ["B08F2NDB39", "B09D4SZL87", "B08H1TRGLQ"]
			}else if (this.$data.search.country.toLowerCase() === 'de'){
				return ["B07CNRN566", "B016HX4DFG", "B085HXF3TK"]
			}else if (this.$data.search.country.toLowerCase() === 'fr'){
				return ["B09HXQ1PBL", "B0B68JXJR5", "B09YMY4QRD"]
			}else if(this.$data.search.country.toLowerCase() === 'jp'){
				return ["B094VJXGGL", "B075S1TXFV" ,"B08WPCN86L"]
			}
		}
	},
	components: {
		'copy-sub': COPY_SUB,
		'asin-simple-sub': ASIN_SIMPLE_SUB,
	},
	mounted() {
		window.addEventListener("scroll", this.test, true);
	},
	created() {
		if (this.$route.query.country){
			this.$data.search.country = this.$route.query.country
		}
		if (this.$route.query.asin) {
			this.$data.searchValue = this.$route.query.asin
			this.$options.methods.loadData(this)
		}
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.test, true)
	},
	methods: {
		clickValue : function(value,type) {
			let url = '/index/reverse?asin=' + value + '&country=' + this.$data.searchData.country
			if (type){
				url += "&type="+ type
			}
			window.open(url,'_blank')
		},
		clickSearchTerm: function(searchTerm) {
			let this_ = this
			this_.$data.searchValue = searchTerm
			this.$data.search.page = 1
			this_.$options.methods.loadData(this_)
		},
		tablePageChange: function(val) {
			let this_ = this
			this_.$data.search.page = val
			this_.$options.methods.loadData(this_)
		},
		tableSortChanged: function({ column, prop, order }) {
			this.$data.search.sort = prop + ':' + (order === 'descending' ? 'desc' : 'asc')
			if (this.$data.searchData.total > this.$data.searchData.list.length) {
				this.$options.methods.loadData(this)
			}
		},
		searchFun : function() {
			this.$data.search.page = 1
			this.$options.methods.loadData(this)
		},
		loadData: function(this_) {
			this_ = this_ || this
			if (this_.$data.tableLoading) {
				return
			}
			let asins = this_.$data.searchValue.split(',')
			asins = asins.filter(i => i)
			if (asins.length <= 0) {
				this_.F_alertMsg('请输入ASIN再查询', 3)
				return;
			}
			for (let asin of asins) {
				if (!regular.amzAsin.test(asin)) {
					this_.F_alertMsg('ASIN格式错误，请检查ASIN', 3)
					return;
				}
			}
			let obj = JSON.parse(JSON.stringify(this_.$data.search))
			obj.searchTerm = asins.join(',')
			this_.$data.tableLoading = true
			api_sourcesList_traffic(obj).then(res => {
				let data = res.data
				if (data.variations){
					data.list.forEach(i => {
						i.attributes = data.variations.find(i2 => i.asin === i2.asin).attributes
					})
					delete data.variations
				}
				this_.$data.searchData = data
				//关闭遮罩
				this_.$data.tableLoading = false
			}).catch(err => {
				//关闭遮罩
				this_.$data.tableLoading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败'), 4)
			})
		},
		test: function() {
			throttle(this.$options.methods.scrollLoadFun(this))
		},
		scrollLoadFun: function(this_) {
			this_ = this_ || this
			let elTableDom = this_.$refs['elTable']
			if (elTableDom){
				let elHeader = elTableDom.$el.querySelector('.el-table__header-wrapper')
				let { top, left } = elTableDom.$el.getBoundingClientRect()
				if (top <= 60) {
					elTableDom.$el.style.paddingTop = '60px'
					elHeader.style.position = 'fixed'
				} else {
					elTableDom.$el.style.paddingTop = '0'
					elHeader.style.position = null
				}
			}
		},
		onCopy: function() {
			this.F_alertMsg('复制成功', 2)
		},
		onError: function() {
			this.F_alertMsg('复制错误', 3)
		},
		getTagType: function(num, type) {
			return num > 0 ? type : 'info'
		},
		getCountryObjByCity: function(val) {
			return getCountryObjByCity(val)
		},
		toThousands: function(val) {
			return toThousands(val)
		},
	},
	watch: {
		windowObj: {
			handler() {
			},
			deep: true
		},
		loginUser: {
			handler() {
			},
			deep: true
		}
	},
}
</script>

<style scoped>
.reversing-index-main-div {
	margin: auto;
}
.head-div {
	padding: 80px 13%;
}
/*示例展示*/
.head-div .example-div {
	font-size: 14px;
	color: #bfbfbf !important;
	text-align: center;
}
.head-div .example-div a {
	display: inline-block;
	color: #bfbfbf;
	border-bottom: 1px dashed #bfbfbf;
	margin-right: 20px;
}
.head-div .example-div a:hover {
	color: #faad14;
	border-bottom: 1px dashed #faad14;
}

/*搜索栏*/
.search-bar-div {
	display: flex;
	margin: 5px 27px;
	font-size: 14px;
}
.search-bar-div .group {
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	height: 100%;
}
.search-bar-div .country-select-div {
	width: 80px;
	border: 1px solid #DCDFE6;
	background-color: rgba(245, 247, 250);
	box-sizing: border-box;
	border-right: 0;
	padding: 0 20px;
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}
.search-bar-div .search-div {
	border: 1px solid #409EFF;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
	box-sizing: border-box;
	border-left: 0;
	overflow: hidden;
}


.body-div {
	font-size: 14px;
}

/*搜索结果预览展示*/
.search-info-div {
	padding: 10px;
}

.search-info-div .condition-div {
	display: flex;
	color: #909399;
}

.table-div {

}

.table-div .asin-div {
	font-size: 12px;
	text-align: center
}

.table-div .link-span {
	cursor: pointer;
}

.table-div .box {
	display: inline-block;
	margin: 4px;
	width: 32px;
	text-align: center;
	font-size: 10px;
	border-radius: 2px;
	/*color: #FFFFFF;*/
	border: 1px solid #EBEEF5;
}

.table-div .user-disabled {
	opacity: 0.5;
}

.body-div .page-div {
	padding: 20px 0;
	text-align: right;
}

</style>
<style>
.country-dropdown-202211111901 > .is-disabled{
	color: #409EFF;
}
.el-select-popper-20220818 .el-select-dropdown__wrap {
	max-height: none;
}

.el-select-20220818 input {
	border: none !important;
}

.el-input-20220818 {
	height: 100%;
}

.el-input-20220818 input {
	border-radius: 0 !important;
	height: 100%;
}

/*评分组件*/
.el-tate-20220818 i {
	font-size: 14px !important;
	margin-right: 0 !important;

}

.el-tate-20220818 span {
	font-size: 14px !important;
	margin-right: 0 !important;

}
/*表格的样式*/
.el-table-20220818 > .el-table__header-wrapper {
	top: 60px;
	z-index: 999;
}

.el-table-header-row-20220818 th {
	background-color: #f5f5f5 !important;
	padding: 5px 0 !important;
}
</style>